/**
 * Go through each discount object and determine if type is excluded.
 *  @params {Object} entry - Discount object.
 *  @params {Object} logic - Product object.
 * - Exclusions override inclusions.
 * - If an earlier type is excluded then skip checking and return false.
 * - If an earlier type is included then continue checking exclusions to
 *   make sure a later type doesn't mean the discount is excluded.
 */
export function checkIncludedOrExcludedProducts(entry, logic) {
  let excluded = false;
  let included = false;

  if (logic?.collectionIds?.length) {
    excluded = entry.exclude.collectionIds?.some((id) => {
      return logic.collectionIds.includes(Number(id));
    });

    included = entry.include.collectionIds?.some((id) => {
      return logic.collectionIds.includes(Number(id));
    });
  }

  if (logic?.productId && !excluded) {
    excluded = entry.exclude.productIds?.some((id) => {
      return logic.productId === Number(id);
    });

    if (!included) {
      included = entry.include.productIds?.some((id) => {
        return logic.productId === Number(id);
      });
    }
  }

  if (logic?.variantId && !excluded) {
    excluded = entry.exclude.variantIds?.some((id) => {
      return logic.variantId === Number(id);
    });

    if (!included) {
      included = entry.include.variantIds?.some((id) => {
        return logic.variantId === Number(id);
      });
    }
  }

  if (excluded) {
    return false;
  }

  return included;
}
